import { ROUTE_IDS, SHELL_IDS } from './route-constants';

export function hasTenantRouteAccess(route, tenantAccess = {}) {
  if (!route) {
    return false;
  }

  if (route.shell === SHELL_IDS.ADMIN) {
    return true;
  }

  if (tenantAccess?.capabilityState === 'unavailable' || tenantAccess?.capabilityState === 'blocked') {
    return false;
  }

  const hasExplicitEnabledModuleKeys = Array.isArray(tenantAccess?.enabledModuleKeys);
  const hasExplicitVisibleRouteIds = Array.isArray(tenantAccess?.visibleRouteIds);
  const enabledModuleKeys = hasExplicitEnabledModuleKeys ? tenantAccess.enabledModuleKeys : [];
  const visibleRouteIds = hasExplicitVisibleRouteIds ? tenantAccess.visibleRouteIds : [];
  const moduleEnabled =
    !route.moduleKey ||
    !hasExplicitEnabledModuleKeys ||
    enabledModuleKeys.includes(route.moduleKey);
  const routeVisible =
    !hasExplicitVisibleRouteIds ||
    visibleRouteIds.includes(route.id);

  return moduleEnabled && routeVisible;
}

export function hasRequiredRouteCapabilities(route, capabilities = {}) {
  const requiredCapabilities = route?.access?.requiredCapabilities || [];

  return requiredCapabilities.every((capabilityKey) => Boolean(capabilities[capabilityKey]));
}

export function canAccessAppRoute({
  route,
  tenantAccess,
  currentUser,
  capabilities = {},
}) {
  if (!hasTenantRouteAccess(route, tenantAccess)) {
    return false;
  }

  const requiresAuthentication =
    route.access?.requiresAuthentication ?? route.id !== ROUTE_IDS.SETTINGS;

  if (requiresAuthentication && !currentUser) {
    return false;
  }

  return hasRequiredRouteCapabilities(route, capabilities);
}
